import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AdminModalPermissionsComponent } from '@modules/admin-panel/modals';
import { CollapseModule } from 'ngx-bootstrap/collapse';

@NgModule({
	declarations: [AdminModalPermissionsComponent],
	exports: [AdminModalPermissionsComponent, AdminModalPermissionsComponent],
	imports: [CommonModule, CollapseModule],
})
export class AdminModalPermissionsModule {}
